import React from "react";

function EditorContent({ wrapperRef }) {
  return (
    <main className="flex-1 overflow-y-auto focus:outline-none">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white shadow-lg rounded-lg">
          <div className="toolbar-container p-2 border-b" ref={wrapperRef}>
            {/* Quill toolbar will be inserted here */}
          </div>
          <div className="p-4 min-h-[600px]">
            {/* Quill editor content will be inserted here */}
          </div>
        </div>
      </div>
    </main>
  );
}

export default EditorContent;